import React, { useState } from 'react';
import { CustomisePopoverStyle } from 'pages/home/Content.style';
import { ReactComponent as Emoji } from 'assert/images/Comment/smile.svg';
import clsx from 'clsx';
import Popover from '@mui/material/Popover';

const CustomisePopover = ({ click, customStyle, content }) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event) => {
    setAnchorEl(anchorEl ? null : event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const isOpen = Boolean(anchorEl);

  return (
    <CustomisePopoverStyle className="emoji-container">
      {!click && (
        <div onClick={handleClick} className="emoji-icon">
          <Emoji />
        </div>
      )}
      <Popover
        open={isOpen}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        TransitionProps={{
          timeout: 0,
        }}
        disableAutoFocus
        disableEnforceFocus
      >
        <div className={clsx('emoji-popover', customStyle)}>
          {content || 'Default content'}
        </div>
      </Popover>
    </CustomisePopoverStyle>
  );
};

export default CustomisePopover;
